import { useEffect, useState, type ReactNode } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { I18nextProvider } from "react-i18next";
import { Toaster } from "sonner";
import i18n from "@/lib/i18n";
import { initAuth } from "@/features/auth/stores/authStore";

export function Providers({ children }: { children: ReactNode }) {
  // Refresh silencioso no carregamento (modo real): reidrata o access token (só em
  // memória, ADR-0017) a partir do cookie HttpOnly `rt`, sem exigir novo login
  // após reload.
  useEffect(() => {
    void initAuth();
  }, []);

  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30_000,
            refetchOnWindowFocus: false,
            retry: 1,
          },
          mutations: {
            retry: 0,
          },
        },
      }),
  );

  return (
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        {children}
        <Toaster position="top-right" richColors closeButton />
        {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
      </QueryClientProvider>
    </I18nextProvider>
  );
}
